import {StreamErrorMessage, StreamErrorType} from "../../../../types";

// ErrorReason has a notice for some error types only. The other types show the
// user nothing. This is the one place that decides, so a caller that must know
// whether an error is explained cannot drift away from what ErrorReason draws.
export const errorNotices = (
    value: StreamErrorMessage | undefined,
    rateLimitCount: number
) => {
    const contentFilter =
        !!value &&
        (value.errorType === StreamErrorType.ContentFilter ||
            (value.errorType === StreamErrorType.Unknown &&
                value.message.includes("content_filter")));
    return {
        contentFilter,
        unknown: !contentFilter && value?.errorType === StreamErrorType.Unknown,
        contextLength:
            value?.errorType === StreamErrorType.ContextLengthExceeded,
        rateLimit:
            value?.errorType === StreamErrorType.RateLimitExceeded &&
            rateLimitCount > 1,
    };
};

export const hasErrorNotice = (
    value: StreamErrorMessage | undefined,
    rateLimitCount: number
) => Object.values(errorNotices(value, rateLimitCount)).some(Boolean);
